module.exports = __webpack_public_path__ + "img/no_demographics_for_less_than_100_fans_2x.png";